import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface Props {
  selected: EmployeeForSelectFragmentNoAccess[]
  setSelected: (value: EmployeeForSelectFragmentNoAccess[]) => void
}

const EmployeeFilter = ({ selected, setSelected }: Props) => {
  return (
    <Filter.EntitySelector
      label={i18n.t('common.employee')}
      value={selected}
      nameAttribute={'fullName'}
      onValueChange={() => {}}
      component={() => (
        <EmployeeSelector
          alwaysOpen
          hideBorder
          multiple
          value={selected}
          onSelect={(selectedEmployees) => setSelected(selectedEmployees)}
        />
      )}
    />
  )
}

export default EmployeeFilter
